import { REQUEST } from '~/middleware/ndsRequest';

const requestData = (options) => ({
  [REQUEST]: options,
});

export const SeismicActionTypes = {
  LOAD_EVENT: 'loadSeismicEvent',
  LOAD_SEISMIC: 'loadSeismicWave',
};

export default {
  getSeismicEvent: ({ page = 1 }) => (dispatch) => {
    const options = {
      type: SeismicActionTypes.LOAD_EVENT,
      endpoint: `/rest/seismic/event?page=${page}`,
      method: 'GET',
    };

    return dispatch(requestData(options));
  },

  getSeismicWave: ({ station, dateTime }) => (dispatch) =>
    dispatch(
      requestData({
        type: SeismicActionTypes.LOAD_SEISMIC,
        endpoint: `/rest/seismic?station=${station}&start_date=${dateTime}`,
        method: 'GET',
      }),
    ),
};



// WEBPACK FOOTER //
// ./resources/assets/js/actions/seismic.js